import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '@mui/material';
import { debounce } from 'essential-utils';
import * as React from 'react';
import { FlexBox } from '../../box';
import { Chip } from '../../chip';
import { MoreButton } from './facility-more-button';
export const FacilityFilter = (props) => {
    const { selected, tags, onFilter } = props;
    const { spacing } = useTheme();
    const [showMore, setShowMore] = React.useState(false);
    const [moreIndex, setMoreIndex] = React.useState(Number.MAX_SAFE_INTEGER);
    const [moreRows, setMoreRows] = React.useState(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onChips = React.useCallback(debounce((el) => {
        if (!el) {
            return;
        }
        const htmlChips = el.querySelectorAll('[data-role="chip"]');
        const moreButton = el.querySelector('[data-role="more-button"]');
        let oldTop = htmlChips[0]?.getBoundingClientRect().top ?? 0;
        const index = Array.from(htmlChips).reduce((memo, chip, i) => {
            const { top } = chip.getBoundingClientRect();
            if (top !== oldTop) {
                return memo;
            }
            oldTop = top;
            return i;
        }, Number.MIN_SAFE_INTEGER);
        oldTop = htmlChips[0]?.getBoundingClientRect().top ?? 0;
        setMoreRows(Array.from(htmlChips).reduce((memo, chip) => {
            const { top } = chip.getBoundingClientRect();
            let newMemo = memo;
            if (top !== oldTop) {
                newMemo = Math.min(newMemo + 1, 2);
            }
            oldTop = top;
            return newMemo;
        }, 0));
        if (moreButton && index !== Number.MAX_SAFE_INTEGER) {
            const newIndex = index + 1;
            setMoreIndex(newIndex);
        }
    }, 0), []);
    React.useEffect(() => {
        return onChips.cancel;
    }, [onChips]);
    const overflow = (() => {
        if (showMore) {
            return 'auto';
        }
        if (moreIndex === Number.MAX_SAFE_INTEGER) {
            return 'hidden';
        }
        return undefined;
    })();
    const mainTags = tags.slice(0, moreIndex);
    const otherTags = tags.slice(moreIndex);
    const moreButtonDisplayCss = {
        visibility: moreRows === 0 ? 'hidden' : 'visible'
    };
    return (_jsxs(FlexBox, { flexWrap: "wrap", overflow: overflow, height: showMore ? (moreRows === 1 ? 70 : 98) : 38, gap: 0.75, padding: [1, 2], my: -1, position: "relative", visibility: moreIndex === Number.MAX_SAFE_INTEGER ? 'hidden' : 'visible', sx: {
            overflowY: showMore && moreRows >= 2 ? 'auto' : 'hidden',
            overscrollBehavior: 'contain',
            transition: 'height 0.3s',
            scrollbarGutter: 'stable'
        }, ref: onChips, children: [_jsx(MoreButton, { active: !showMore && otherTags.some((t) => selected.includes(t)), sx: moreIndex === Number.MAX_SAFE_INTEGER
                    ? { ...moreButtonDisplayCss, height: 22 }
                    : {
                        ...moreButtonDisplayCss,
                        height: 22,
                        position: 'absolute',
                        right: spacing(2)
                    }, onClick: () => setShowMore?.(!showMore) }), [...mainTags, ...(showMore ? otherTags : [])].map((tag) => (_jsx(Chip, { label: tag.name, selected: selected.includes(tag), onClick: () => {
                    if (selected.includes(tag)) {
                        onFilter?.(selected.filter((t) => t !== tag));
                    }
                    else {
                        onFilter?.([...selected, tag]);
                    }
                } }, tag.name)))] }));
};
